<div class="w-full flex flex-col gap-1">
    @if (label) {
        <label class="font-bold text-black" for="cep">{{label}}</label>
    }
    <p-inputMask
        [id]="id"
        [placeholder]="placeholder"
        [disabled]="isReadOnly || isDisabledByForm"
        [(ngModel)]="value"
        (blur)="onBlur.emit($event)"
        (keypress)="keyPress($event)"
        autocomplete="off"
        mask="99999-999"
        class="block w-full min-w-0 [&_input]:w-full [&_input]:h-8 [&_input]:bg-white [&_input]:border [&_input]:border-gray-300 [&_input]:rounded-lg [&_input]:px-3 [&_input]:text-sm [&_input]:focus:outline-none [&_input]:focus:ring-2 [&_input]:focus:ring-emerald-300"
    ></p-inputMask>
</div>
